// Port of api/fuel/app/classes/filter/package/games/game/package/tags.php
export default {
	run: function(pkg, local) {
		pkg.tags = (local.tags || []).map(function(t) { return parseInt(t) }).filter(function(t) { return t > 0 })
		return pkg
	}
}
